import Navbar from "../navbar/navbar";
import Video_section from "../video_section/video_section";
import TopDishes from "../top_dishes/topDishes";
import Top_most_dish from "../top_most_dish/top_most_dish";
// import Top_worker from "../Top_worker/top_worker";
import Statistics from "../statistics/statistics";
import Carousel from "../carousel/carousel";
// import Rating from "../rating/rating";
import Footer from "../footer/footer";
import ScrollToTop from "../scroll/scroll";
import Info from '../info/Info'
import React from "react";
import './home_page.css'

const Home_page = () => {
    return (
        <div className={'hhh'}>
            <Navbar/>
            <Video_section/>
            <Info/>
            {/*<TopDishes/>*/}
            {/*<Top_most_dish/>*/}
            {/*<Top_worker/>*/}
            {/*<Statistics filial={10} mehmon={1000} oshpaz={300} taom={200}/>*/}
            <Carousel/>
            {/*<Rating/>*/}
            <Footer/>
            <ScrollToTop showBelow={250}/>
        </div>
    )
}
export default Home_page